export type EdiCardChipKind = "default" | "success" | "warning";

export const EDI_CHIP_STYLES: Record<
  EdiCardChipKind,
  { bg: string; color: string }
> = {
  default: { bg: "#F3F4F6", color: "#4B5563" },
  success: { bg: "#ECFDF5", color: "#047857" },
  warning: { bg: "#FFFBEB", color: "#92400E" },
};

export const getCardSx = (borderColor: string) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  px: 2,
  py: 1.25,
  borderRadius: "10px",
  border: "1px solid",
  borderColor,
  backgroundColor: "white",
  cursor: "pointer",
  transition: "box-shadow 120ms ease-out",
  "&:hover": {
    boxShadow: "0px 2px 8px rgba(15, 23, 42, 0.06)",
  },
});
